import React from 'react';
import { motion } from 'framer-motion';

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

const PageLayout = ({ children, title, subtitle }: PageLayoutProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-primary-50/30 via-transparent to-transparent"></div>
      <div className="absolute inset-0 pattern-dots opacity-5"></div>

      {/* Page header, with expanded pt to clear global transparent navbar */}
      <header className="relative pt-36 pb-20 md:pt-48 md:pb-24 bg-gradient-to-r from-primary-600 to-primary-500 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-white/20 via-primary-500/10 to-transparent"></div>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-white/10 via-transparent to-transparent"></div>
          <div className="absolute inset-0 pattern-dots opacity-10"></div>
        </div>
        <div className="relative container-padding">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 text-shadow-sm">
              {title}
            </h1>
            {subtitle && (
              <p className="text-xl text-white/90 max-w-2xl mx-auto">
                {subtitle}
              </p>
            )}
          </motion.div>
        </div>
      </header>

      {/* Main content */}
      <main className="relative py-16 md:py-24">
        <div className="container-padding">
          {children}
        </div>
      </main>
    </div>
  );
};

export default PageLayout;
